import { render } from "./ProjectShowOverview.vue?vue&type=template&id=3506612b"
import script from "./ProjectShowOverview.vue?vue&type=script&lang=js"
export * from "./ProjectShowOverview.vue?vue&type=script&lang=js"
script.render = render

export default script